import { Col, List, Row, Space, Typography } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import { PaymentMethod, PaymentMethods } from './types';

type Props = {
    item: PaymentMethod;
    onEdit?: () => void;
    onDelete?: () => void;
    disabled?: boolean;
};

const { Text } = Typography;

const PaymentMethodItem = ({ onEdit, onDelete, item, disabled }: Props) => {
    const { paymentMethod } = item;

    const methodName = paymentMethod === PaymentMethods.PAY_PAL ? 'PayPal' : 'Bank Transfer';
    const details =
        paymentMethod === PaymentMethods.PAY_PAL ? (
            <>
                <Col span={17}>
                    <Text>URL: </Text>
                    <Typography.Link
                        style={{ textDecoration: 'underline', color: 'var(--brand-6)', fontWeight: 600 }}
                        href={item.url}
                        target="_blank"
                        rel="noreferrer"
                    >
                        {item.url}
                    </Typography.Link>
                </Col>
            </>
        ) : (
            <>
                <Col span={5}>
                    <Text>Bank Name:</Text> <Text strong>{item?.bankName ?? '-'}</Text>
                </Col>
                <Col span={7}>
                    <Text>IBAN:</Text> <Text strong>{item?.iban ?? '-'}</Text>
                </Col>
                <Col span={5}>
                    <Text>BIC:</Text> <Text strong>{item?.bic ?? '-'}</Text>
                </Col>
            </>
        );

    return (
        <List.Item>
            <Space direction="vertical" size={2} style={{ width: '100%' }}>
                <Row gutter={[16, 8]} align="middle">
                    <Col span={5}>
                        <Text>Payment Method:</Text> <Text strong>{methodName}</Text>
                    </Col>
                    {details}
                    {!disabled && (
                        <Col
                            span={2}
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 8,
                            }}
                        >
                            <IconButton
                                tooltipText="Edit"
                                onClick={onEdit}
                                icon={<EditOutlined style={{ fontSize: 16 }} />}
                            />
                            <IconButton
                                tooltipText="Delete"
                                onClick={onDelete}
                                icon={<DeleteOutlined style={{ fontSize: 16 }} />}
                            />
                        </Col>
                    )}
                </Row>
            </Space>
        </List.Item>
    );
};

export default PaymentMethodItem;
